/* unplugin-vue-components disabled */import script from "./TagButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagButton.vue?vue&type=script&setup=true&lang=ts"

import "./TagButton.vue?vue&type=style&index=0&id=0f887562&lang=less"

const __exports__ = script;

export default __exports__